import { Pipe, PipeTransform } from '@angular/core';
import { MissionRequest } from '../../models/mission/mission-request';

@Pipe({
	name: 'filterFormationBySkill'
})
export class FilterFormationBySkillPipe implements PipeTransform {
	transform(
		formations: MissionRequest[],
		filter: string | string[],
		centerType?
	): MissionRequest[] {
		if (
			formations === null ||
			!filter ||
			filter.length === 0 ||
			filter === ''
		) {
			return formations;
		}

		if (!Array.isArray(filter)) {
			filter = [filter];
		}

		const formationsFiltered = formations.filter((missionRequest) => {
			// const careSkillName = missionRequest?.careSkill
			// 	? missionRequest?.careSkill.name
			// 	: missionRequest?.beneficiaire?.careSkill.name;
			for (const comp of filter) {
				//if (careSkillName.toLowerCase().includes(comp.toLowerCase())) {
					return true;
				//}
			}
			return false;
		});

		return formationsFiltered;
	}
}
